import { render } from "./TabelaBairro.vue?vue&type=template&id=5d123c1c&scoped=true"
import script from "./TabelaBairro.vue?vue&type=script&lang=js"
export * from "./TabelaBairro.vue?vue&type=script&lang=js"

import "./TabelaBairro.vue?vue&type=style&index=0&id=5d123c1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d123c1c"]])

export default __exports__